import { Inject, Injectable } from "@angular/core";
import { EventComplete } from "../models/events/event-complete.model";
import { EventTicketComplete } from "../models/event-tickets/event-ticket-complete.model";

@Injectable()
export class EventHelper {
    _event:EventComplete;
    constructor(@Inject('lrpEvent') lrpEvent: EventComplete) {
        this._event = lrpEvent;
    }
    
    get playerCount(): number { 
        return this._event.eventBookings
        .filter(x => x.bookingType === 'Player' && x.paid ).length ?? 0
    }

    get crewCount(): number {
        return this._event.eventBookings
          .filter(x => x.bookingType === 'Crew' && x.paid ).length ?? 0
    }

    get staffCount(): number {
        return this._event.eventBookings
          .filter(x => x.bookingType === 'staff' && x.paid ).length ?? 0
    }
    
    get getPendingCount(): number {
        return this._event?.eventBookings
          .filter(x => x.bookingType === 'player' && !x.paid ).length ?? 0
    }
    
    get getConfirmedIncome(): number {
        if (this._event?.eventBookings){
            return this._event?.eventBookings
                .flatMap(x => x.totalPaid)
                .reduce((acc, value) => acc + value, 0)
        }
        return 0;
    }
    
    get getPaypalCosts(): number {
        if (this._event?.eventBookings){
            return this._event?.eventBookings
                .filter(x => x.paypalPaymentId)
                .flatMap(x => x.totalPaid)
                .reduce((acc, value) => acc + this.calculatePaypalFee(value), 0)
        }
        return 0;
    }

    get playerTickets(): EventTicketComplete[] {
        return this._event.eventTickets?.filter(x => x.name === 'Player' && x !== undefined) ?? [];
    }

    get crewTickets(): EventTicketComplete[] {
      return this._event.eventTickets?.filter(x => x.name === 'Crew' && x !== undefined) ?? [];  
    }

    get staffTickets(): EventTicketComplete[] {
        return this._event.eventTickets?.filter(x => x.name === 'Staff' && x !== undefined) ?? [];
    }

    
    private calculatePaypalFee(value:number): number {
        const paypalFixedFee = this._event?.eventHost.paypalFixedFee;
        const paypalPercFee = (this._event?.eventHost.paypalPercentage / 100);
        return (value * paypalPercFee) + paypalFixedFee;
    }
}

